import { render, staticRenderFns } from "./FilterAssembly.vue?vue&type=template&id=2254424e&scoped=true&"
import script from "./FilterAssembly.vue?vue&type=script&lang=js&"
export * from "./FilterAssembly.vue?vue&type=script&lang=js&"
import style0 from "./FilterAssembly.vue?vue&type=style&index=0&id=2254424e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254424e",
  null
  
)

export default component.exports